import React, { useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { createApplicantFromGitHubByRecruiter } from '../../Services/applicantService';
import UserTopRepositories from './UserTopRepositories';

const GitHubUserCard = ({ user, jobId }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isAddedToJob, setIsAddedToJob] = useState(false);

  const handleAddToJob = () => {
    setIsLoading(true);
    createApplicantFromGitHubByRecruiter({ ...user, jobId })
      .then(() => {
        setIsAddedToJob(true);
      })
      .catch((error) => {
        console.error('Error adding applicant:', error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Col md={6} key={user.login} className="mb-3">
      <div className="p-2 border rounded">
        <Row>
          <Col xs={3} className="d-flex justify-content-center align-items-center">
            <img src={user.avatarUrl} alt={user.login} className="img-fluid rounded-circle" />
          </Col>
          <Col xs={9}>
            <h6 className="mb-0">
              <a href={user.url} target="_blank" rel="noopener noreferrer">
                {user.name || user.login}
              </a>
            </h6>
            <p className="small text-muted">{user.location}</p>
            <p className="small">{user.bio}</p>
            <div className="small mt-2">
              {user.email && (
                <div>
                  <strong>Email:</strong> {user.email}
                </div>
              )}
              {user.twitterUsername && (
                <div>
                  <strong>X:</strong>{' '}
                  <a href={`https://twitter.com/${user.twitterUsername}`} target="_blank" rel="noopener noreferrer">
                    {user.twitterUsername}
                  </a>
                </div>
              )}
              {user.websiteUrl &&
                (user.websiteUrl.includes('linkedin.com') ? (
                  <div>
                    <strong>LinkedIn:</strong>{' '}
                    <a href={user.websiteUrl} target="_blank" rel="noopener noreferrer">
                      {user.websiteUrl}
                    </a>
                  </div>
                ) : (
                  <div>
                    <strong>Website:</strong>{' '}
                    <a href={user.websiteUrl} target="_blank" rel="noopener noreferrer">
                      {user.websiteUrl}
                    </a>
                  </div>
                ))}
            </div>
            <p className="small">
              <strong>Followers:</strong> {user.followers?.totalCount} | <strong>Following:</strong>{' '}
              {user.following?.totalCount}
            </p>
          </Col>
        </Row>
        {user.repositories?.nodes?.length > 0 && (
          <>
            <UserTopRepositories user={user} />
            <div className="d-flex justify-content-end">
              <Button color="primary" size="sm" onClick={handleAddToJob} disabled={isLoading || isAddedToJob}>
                {isLoading ? 'Adding...' : isAddedToJob ? 'Added' : 'Add To Job'}
              </Button>
            </div>
          </>
        )}
      </div>
    </Col>
  );
};

export default GitHubUserCard;
